export default {
  default: () => import("/builds/zone/dev/web/zone-service-top/layouts/default.vue").then(m => m.default || m),
  "error-template": () => import("/builds/zone/dev/web/zone-service-top/layouts/error-template.vue").then(m => m.default || m),
  "lp-template": () => import("/builds/zone/dev/web/zone-service-top/layouts/lp-template.vue").then(m => m.default || m),
  "not-reset-template": () => import("/builds/zone/dev/web/zone-service-top/layouts/not-reset-template.vue").then(m => m.default || m)
}